import adobeCep from "./adobeCep/index.js"
import cli from "./cli/index.js"
import executable from "./executable/index.js"
import generatorCorePlugin from "./generatorCorePlugin/index.js"
import githubAction from "./githubAction/index.js"
import html from "./html/index.js"
import nodeClass from "./nodeClass/index.js"
import nodeLib from "./nodeLib/index.js"
import nodeScript from "./nodeScript/index.js"
import reactDomComponent from "./reactDomComponent/index.js"
import universalClass from "./universalClass/index.js"
import universalLib from "./universalLib/index.js"
import webapp from "./webapp/index.js"

const types = {
  adobeCep,
  cli,
  executable,
  generatorCorePlugin,
  nodeClass,
  githubAction,
  nodeLib,
  nodeScript,
  universalClass,
  universalLib,
  webapp,
  html,
  reactDomComponent,
}

export default types